import React from 'react';
import SEO from '../components/SEO';
import Footer from '../components/Footer';
import { ArrowLeft, SearchX } from 'lucide-react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO
        title="Seite nicht gefunden | Arabicroots"
        description="Die gesuchte Seite wurde nicht gefunden."
        url="/404"
        noIndex={true}
      />

      {/* Header */}
      <header className="bg-white border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center group">
              <img
                src="/LogoHeader4.png"
                alt="Arabicroots Logo"
                className="h-12 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.03]"
              />
            </Link>
            <Link
              to="/"
              className="flex items-center text-gray-600 hover:text-[#970000] transition-colors duration-200"
            >
              <ArrowLeft className="h-5 w-5 mr-2" />
              Zurück zur Startseite
            </Link>
          </div>
        </div>
      </header>

      {/* Main */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="mb-12">
          <div className="inline-flex items-center rounded-full bg-[#970000]/10 text-[#970000] px-4 py-2 text-sm font-semibold mb-6">
            <SearchX className="h-4 w-4 mr-2" />
            Fehler 404
          </div>

          <h1 className="text-3xl md:text-5xl font-bold text-gray-900 leading-tight mb-4">
            Seite nicht gefunden
          </h1>

          <p className="text-lg text-gray-600 leading-relaxed">
            Die gesuchte Seite existiert leider nicht oder wurde verschoben.
          </p>
        </div>

        <div className="space-y-8">
          <section className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 md:p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Was möchtest du tun?
            </h2>
            <div className="space-y-3 text-gray-700 text-base leading-relaxed">
              <p>
                Die aufgerufene Seite konnte nicht gefunden werden. Bitte überprüfe die
                URL oder navigiere zurück zur Startseite.
              </p>
              <div className="pt-4 flex flex-col sm:flex-row gap-3">
                <Link
                  to="/"
                  className="inline-flex items-center justify-center px-6 py-3 rounded-xl bg-[#970000] text-white font-semibold hover:bg-[#7a0000] transition-colors duration-200"
                >
                  <ArrowLeft className="h-4 w-4 mr-2" />
                  Zur Startseite
                </Link>
                <Link
                  to="/anmelden"
                  className="inline-flex items-center justify-center px-6 py-3 rounded-xl border border-gray-200 bg-white text-gray-700 font-semibold hover:border-[#970000] hover:text-[#970000] transition-colors duration-200"
                >
                  Jetzt anmelden
                </Link>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NotFoundPage;
